//TODO: Move constants from server folder to here so that we can use the same constants across both server and client directory

export const CONSUMER = 'consumer'
export const MERCHANT = 'merchant'
// min characters required for search
export const MIN_LENGTH_SEARCH_CHAR = 2
// max characters required for search
export const MAX_LENGTH_SEARCH_CHAR = 100
export const PERSONAL = 'personal'
export const BUSINESS = 'business'
export const TECHNICAL = 'technical'
export const JP = 'JP'
export const PAYPAL_OBJECTS_BASE_URL = 'https://www.paypalobjects.com'
export const YT_IFRAME_SCRIPT_URL = 'https://www.youtube.com/iframe_api'
export const pageNames = {
  HOME: 'home',
  ARTICLE: 'article',
  TOPIC: 'topic',
  HELP_GUIDES: 'helpGuides',
  SEARCH: 'search',
  PERSONAL: 'personal',
  BUSINESS: 'business',
  TECHNICAL: 'technical',
  COMPLAINTS: 'complaints',
}
export const signInUri = '/signin/?returnUri='
export const AUTHFLOW_PASSWORD_RECOVERY_URL = '/authflow/password-recovery'
export const FAQ = 'FAQ'
export const INTENT_TYPE_GENERIC = 'GENERIC'
export const chatBotMessageUsRefIdsMapping = {
  GENPOOL_CONTACT_US: 'GENPOOL|contactUsPage',
  GENERIC: 'GENPOOL',
  FINAL_INTENT: 'finalIntent',
  GENPOOL_ARTICLE_PAGE: 'GENPOOL|articlePage',
  GENPOOL_HOME_PAGE: 'GENPOOL|homePage',
}
export const BNA = 'BNA'
export const OMNI = 'OMNI'
export const MTS = 'MTS'
export const FAQ_CHANNELS = [FAQ, MTS]
export const NON_FAQ_CHANNELS = [OMNI, BNA]
export const recommendedSolutionsTitleLimits = {
  desktop: 36,
  tablet: 36,
  mobile: 21,
}
export const deviceTypes = {
  desktop: 'desktop',
  tablet: 'tablet',
  mobile: 'mobile',
}
export const COMPLAINT_REASON_CODE = 'complaintReasonCode'
export const COMPLAINT_REASON_CODES = {
  FEEDCOMPLAIN011: 'FEEDCOMPLAIN011',
  FEEDCOMPLAIN012: 'FEEDCOMPLAIN012',
  FEEDCOMPLAIN013: 'FEEDCOMPLAIN013',
  FEEDCOMPLAIN014: 'FEEDCOMPLAIN014',
  FEEDCOMPLAIN019: 'FEEDCOMPLAIN019',
}
export const POSITIONS = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
}

export const YES = 'yes'
export const NO = 'no'

export const SEARCH_ERROR_TYPES = {
  MIN_SEARCH_QUERYVALIDATION_ERROR: 'Min search query validation error',
  MAX_SEARCH_QUERYVALIDATION_ERROR: 'Max search query validation error',
  NO_SEARCH_RESULTS_ERROR: 'No search results for the search query',
  SEARCH_RESULTS_SERVICE_ERROR: 'API/Service error',
}
